import { useFormik } from "formik";
import globalMU from "globalMU";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  DadosParcela,
  CampoContaPortadora as ContaPortadora,
  TipoParcela,
  CampoTipoDocumento as TipoDocumento,
  ErroIncluirEditarParcela,
} from "../../../types/IncluirEditarParcela";
import { InputMascara } from "../../inputs/InputMascara";
import { InputNumerico } from "../../inputs/InputNumerico";
const estiloIncluirEditarParcela = require("./incluir-editar-parcela.module.scss").default;
const estilosFormulario = require('../../../estilos/formulario.module.scss').default;
const estilosBotoes = require('../../../estilos/botoes.module.scss').default;
import * as R from 'ramda';
import { InputData } from "app/components/inputs/InputData";
import { encontrarTipoDocumentoPorTipoParcela } from "./encontrarTipoDocumentoPorTipoParcela"; // 489850

export type IncluirEditarParcelaProps = {
  somenteLeitura: boolean;
  ativarRecebimentoPixAPrazo?: boolean; //414608
  parcela: DadosParcela;
  listaQuantidadeParcelas: number[];
  contasPortadoras: ContaPortadora[];
  tiposParcelas: TipoParcela[];
  tiposDocumento: TipoDocumento[];
  onSelecionarDataVencimento: () => void;
  onGerarlistaQuantidadeParcelas: () => void;
  onAplicar: (incluirEditarParcelaFormulario: DadosParcela) => void;
  onErrorValidacao: (erroIncluirEditarParcela: ErroIncluirEditarParcela) => void;
  desativarEdicaoValor: boolean;
  desativarSelecaoTipo: boolean;
  desativarEdicaoTipoDocumento: boolean;
  desativarEdicaoDataVencimento: boolean;
  exibirCheckboxReceberNaEntrega: boolean;
  onParcelaModificada: (parcela: DadosParcela) => void;
  valorParcelasCartao: number;
  onValidarRecebimentoEntrega: (dadosParcela: DadosParcela) => void;
  onValidarContaPortadorTipoDocumento: (parcela: DadosParcela) => void;
};

export const IncluirEditarParcela = React.memo((props: IncluirEditarParcelaProps) => {
  const [validado, setValidado] = useState(false);
  const [pixAPrazoHabilitado, setPixAPrazoHabilitado] = useState(false); //414608

  const obterDadosParcelaDaProps = useCallback((): DadosParcela => ({
    ...props.parcela
  }), [props.parcela]);

  const formik = useFormik({
    initialValues: obterDadosParcelaDaProps(),
    onSubmit: () => {}, // Função vazia, pois o submit é tratado no botão "Aplicar"
    enableReinitialize: true,
    validate: (values) => {
      const mensagemObrigatorio = (campo: string) => `O campo "${campo}" é obrigatório.`;

      return R.pickBy(val => globalMU.isNotNullOrEmpty(val), {
        Tipo: values.Tipo == undefined || globalMU.isNullOrEmpty(values.Tipo) ? mensagemObrigatorio("tipo") : undefined,
        IdTipoDocumento: values.IdTipoDocumento == undefined || globalMU.isNullOrEmpty(values.IdTipoDocumento) ? mensagemObrigatorio("tipo documento") : undefined,
        Vencimento: (values.Vencimento == undefined || globalMU.isNullOrEmpty(values.Vencimento)) ? mensagemObrigatorio("vencimento") : undefined,
        Valor: values.Valor == undefined || values.Valor <= 0 || globalMU.isNullOrEmpty(values.Valor) ? mensagemObrigatorio("valor") : undefined
      });
    },
  });

  const validacaoTipoDocumento = useCallback((tipoDocumento: TipoDocumento, tipoParcelaResolvido: number) => {

    if (tipoDocumento == null) { return false; } // 466224

    if (tipoParcelaResolvido !== 1 && tipoDocumento.Tipo == 17763) { // 466224
      return true
    }
    else  // 466224
    if (tipoParcelaResolvido == 2) {
      return tipoDocumento.TipoParcela == 2;
    }
    if (tipoDocumento.TipoParcela != 2 && tipoDocumento.Tipo == 17763) {
      return tipoDocumento.QuantidadeMaximaParcelaVista >= 1;
    }
    if (R.includes(tipoDocumento.TipoParcela, [0, 1]) && tipoDocumento.Tipo != 17763) {
      return true;
    }
    return false;
  }, []);

  const exibirTipoDocumento = useCallback((tipoDocumento: TipoDocumento): boolean => {

    const tipoParcela = formik.values.Tipo;
    const tipoParcelaResolvido = R.includes(tipoParcela, [0, 1]) ? 0 : tipoParcela;
    return validacaoTipoDocumento(tipoDocumento, tipoParcelaResolvido);
  }, [formik.values.Tipo, validacaoTipoDocumento]);

  useEffect(() => {

    formik.setValues({
      ...formik.values,
      ...obterDadosParcelaDaProps()
    })
    
    const tipoDocumento = props.tiposDocumento.find(tipoDocumento => tipoDocumento.Codigo == props.parcela.IdTipoDocumento) //414608
    setPixAPrazoHabilitado(
      props.ativarRecebimentoPixAPrazo && 
      (
      (tipoDocumento && tipoDocumento?.PixAPrazoHabilitadoParaCobranca) 
      || 
      (!tipoDocumento && props.parcela.DocumentoElegivelPIXaPrazo)
    )
   ) //414608

  }, [props.parcela])

  useEffect(() => {
    if ((props.listaQuantidadeParcelas ?? []).length == 1) {
      formik.setFieldValue("QuantidadeParcelasCartao", props.listaQuantidadeParcelas[0])
    }
    else if ((props.listaQuantidadeParcelas ?? []).length == 0) {
      formik.setFieldValue("QuantidadeParcelasCartao", null) // 435811
      formik.setFieldValue("ValorParcelasCartao", null) // 435811
    }
  }, [props.listaQuantidadeParcelas])
/*
  useEffect(() => {
    console.log('values: ', formik.values)
    console.log('errors: ', formik.errors)
  }, [formik.values, formik.errors])
*/
  const selectTipo = useMemo(() => (
    <>
      <label htmlFor="IncluirEditarParcela_Tipo">Tipo</label>
      <select
        id="IncluirEditarParcela_Tipo"
        className={validado && formik.errors.Tipo != undefined ? estilosFormulario.inputComErro : ''}
        style={{ minWidth: "280px" }}
        name="Tipo"
        value={(formik.values.Tipo) ?? ""}
        multiple={false}
        onChange={(e) => {
          formik.handleChange(e);
          props.onParcelaModificada({
            ...formik.values,
            Tipo: globalMU.isNullOrEmpty(e.target.value) ? null : Number(e.target.value)
          });
          const tipoDocumento = encontrarTipoDocumentoPorTipoParcela(props.tiposDocumento, formik.values.IdTipoDocumento, Number(e.target.value)); // 489850
          if (!validacaoTipoDocumento(tipoDocumento, Number(e.target.value))) {
            formik.setFieldValue("IdTipoDocumento", null);
          }
        }}
        disabled={props.somenteLeitura || props.desativarSelecaoTipo}
      >
        <option value="">Selecione</option>
        {props.tiposParcelas?.map((value) => (
          <option key={value.Codigo} value={value.Codigo}>
            {value.Descricao}
          </option>
        ))}
      </select>
    </>
  ), [formik.values.Tipo, formik.errors.Tipo, validado, props.tiposParcelas, props.somenteLeitura, props.desativarSelecaoTipo, validacaoTipoDocumento, props.onParcelaModificada, formik]);

  const inputDataVencimento = useMemo(() => (
    <>
      <label htmlFor="IncluirEditarParcela_Vencimento">Data Vencimento</label>
      <InputData
        id="IncluirEditarParcela_Vencimento"
        className={`_w-[280px]  ${validado && formik.errors.Vencimento != undefined ? estilosFormulario.inputComErro : ''}`}
        disabled={props.somenteLeitura || props.desativarEdicaoDataVencimento}
        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.Vencimento)}
        bloquearDataMenorQueHoje={true}
        onChange={(e) => {
          
          formik.setFieldValue("Vencimento", e);
        }}
        selecionaValorOnFocus
      />
    </>
  ), [formik.values.Vencimento, formik.errors.Vencimento, validado, props.somenteLeitura, props.desativarEdicaoDataVencimento, formik]);

  const selectTipoDocumento = useMemo(() => (
    <>
      <label htmlFor="IncluirEditarParcela_IdTipoDocumento">Tipo Documento</label>
      <select
        id="IncluirEditarParcela_IdTipoDocumento"
        className={validado && formik.errors.IdTipoDocumento != undefined ? estilosFormulario.inputComErro : ''}
        name="IdTipoDocumento"
        disabled={props.somenteLeitura || props.desativarEdicaoTipoDocumento || formik.values.Tipo == null}
        value={(formik.values.IdTipoDocumento) ?? ""}
        multiple={false}
        onChange={e => {

          formik.handleChange(e);

          const idTipoDocumentoSelecionado = globalMU.isNullOrEmpty(e.target.value) ? null : Number(e.target.value);
          // 489850 - o cartão vem em duas facetas com o mesmo Codigo (à vista/TipoParcela 0 e a
          // prazo/TipoParcela 2). Um documento só é "à vista" (e força a parcela para Entrada)
          // quando NÃO existe faceta a prazo para o mesmo Codigo; assim um crédito parcelado
          // (ex.: STONE ... CRED 7A12X) deixa de ser tratado incorretamente como à vista, sem
          // depender da ordem em que a API retorna as ocorrências duplicadas.
          const tipoDocumentoSelecionado = props.tiposDocumento.find(tipoDocumento => tipoDocumento.Codigo == idTipoDocumentoSelecionado);
          const possuiFacetaAPrazo = encontrarTipoDocumentoPorTipoParcela(props.tiposDocumento, idTipoDocumentoSelecionado, 2) != null;
          const documentoAVista = tipoDocumentoSelecionado?.Tipo == 17763 && !possuiFacetaAPrazo;
          const tipoEntrada = documentoAVista && formik.values.Tipo == 2
            ? props.tiposParcelas?.find(tipoParcela => tipoParcela.Descricao == "Entrada")?.Codigo
            : undefined;

          if (tipoEntrada != undefined) {
            formik.setFieldValue("Tipo", tipoEntrada);
          }

          props.onParcelaModificada({
            ...formik.values,
            IdTipoDocumento: idTipoDocumentoSelecionado,
            ...(tipoEntrada != undefined ? { Tipo: tipoEntrada } : {})
          });

          if (!globalMU.isNullOrEmpty(e.target.value)) { // 466224 - quando limpa o combo dava erro desconhecido
          props.onValidarContaPortadorTipoDocumento({
            ...formik.values,
            IdTipoDocumento: idTipoDocumentoSelecionado,
            ...(tipoEntrada != undefined ? { Tipo: tipoEntrada } : {})
          });

          const tipoDocumento = props.tiposDocumento.find(tipoDocumento => tipoDocumento.Codigo == Number(e.target.value)) //414608
          setPixAPrazoHabilitado(tipoDocumento?.PixAPrazoHabilitadoParaCobranca ?? false); //414608

          }
        }}
      >

        {/* estava inseririndo item repetido
        <option value="">Selecione</option>
        {(props.tiposDocumento ?? []).filter(exibirTipoDocumento).map((value) => (
          <option key={value.Codigo} value={value.Codigo}>
            {value.Descricao}
          </option>
        ))} */}


        <option value="">Selecione</option>
        {Array.from(
          new Map(
            (props.tiposDocumento ?? [])
              .filter(exibirTipoDocumento)
              .map((item) => [item.Codigo, item])
          ).values()
        ).map((value) => (
          <option key={value.Codigo} value={value.Codigo}>
            {value.Descricao}
          </option>
        ))}
      </select>
    </>
  ), [formik.values.IdTipoDocumento, formik.values.Tipo, formik.errors.IdTipoDocumento, validado, props.somenteLeitura, props.desativarEdicaoTipoDocumento, exibirTipoDocumento, props.tiposDocumento, props.tiposParcelas, props.onParcelaModificada, formik, props.onValidarContaPortadorTipoDocumento]);

  const checkboxReceberNaEntrega = useMemo(() => (
    <>
      <label htmlFor="incluirEditarParcela_RecebimentoNaEntrega" style={{ cursor: 'pointer' }}>Receber na Entrega</label>
      <input
        type="checkbox"
        id="incluirEditarParcela_RecebimentoNaEntrega"
        name="RecebimentoNaEntrega"
        checked={formik.values?.RecebimentoNaEntrega ?? false}
        disabled={props.somenteLeitura}
        onChange={(e) => {
          props.onValidarRecebimentoEntrega({ ...formik.values, RecebimentoNaEntrega: e.target.checked });
          formik.setFieldValue("RecebimentoNaEntrega", e.target.checked);
        }}
      />
    </>
  ), [formik.values?.RecebimentoNaEntrega, props.somenteLeitura, props.onValidarRecebimentoEntrega, formik]);

  const codigoCMC7 = useMemo(() => (
    <>
      <label htmlFor="IncluirEditarParcela_CodigoCMC7">CMC7</label>
      <InputMascara
        id="IncluirEditarParcela_CodigoCMC7"
        valor={formik.values.CodigoCMC7}
        disabled={props.somenteLeitura}
        onValorModificado={(codigoCMC7) => {
          props.onParcelaModificada({
            ...formik.values,
            CodigoCMC7: codigoCMC7
          });
          formik.setFieldValue("CodigoCMC7", codigoCMC7);
        }}
        mascara={"<99999999<9999999999>999999999999>"}
        permitirMascaraIncompleta={true}
      />
    </>
  ), [formik.values.CodigoCMC7, props.somenteLeitura, props.onParcelaModificada, formik]);

  const numeroParcelasComponent = useMemo(() => (
    <>
      <label htmlFor="EditarParcelaContrato_NumeroParcelas">Nº de Parcelas</label>
      <select
        id="EditarParcelaContrato_NumeroParcelas"
        name="QuantidadeParcelasCartao"
        value={(formik.values.QuantidadeParcelasCartao) ?? ""}
        disabled={props.somenteLeitura || !((props.listaQuantidadeParcelas ?? []).length > 1)}
        multiple={false}
        onChange={e => {
          formik.handleChange(e);
          props.onParcelaModificada({
            ...formik.values,
            QuantidadeParcelasCartao: Number(e.target.value)
          });
        }}
      >
        {((props.listaQuantidadeParcelas ?? []).length > 1) && <option value="">Selecione</option>}
        {props.listaQuantidadeParcelas?.map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </select>
    </>
  ), [formik.values.QuantidadeParcelasCartao, props.listaQuantidadeParcelas, props.somenteLeitura, props.onParcelaModificada, formik]);

  const valorDasParcelasComponent = useMemo(() => (
    <>
      <label htmlFor="EditarParcelaContrato_ValorParcelas">
        Valor das Parcelas {(props.listaQuantidadeParcelas ?? []).length > 1 || formik.values.QuantidadeParcelasCartao > 1 ? '*' : ''}
      </label>
      <div className={estiloIncluirEditarParcela.containerInputNumerico}>
        <InputNumerico
          id="EditarParcelaContrato_ValorParcelas"
          valor={props.valorParcelasCartao ?? 0}
          numeroCasasDecimais={2}
          selecionaValorOnFocus={true}
          campoNullavel={true}
          disabled
        />
      </div>
    </>
  ), [props.valorParcelasCartao, props.listaQuantidadeParcelas, formik.values.QuantidadeParcelasCartao]);

  const valorComponent = useMemo(() => (
    <>
      <label htmlFor="IncluirEditarParcela_Valor">Valor</label>
      <div className={`${estiloIncluirEditarParcela.containerInputNumerico} ${validado && formik.errors.Valor != undefined ? estiloIncluirEditarParcela.validador : null}`}>
        <InputNumerico
          id="IncluirEditarParcela_Valor"
          onValorModificado={valor => formik.setFieldValue("Valor", valor)}
          valor={globalMU.isNullOrEmpty(formik.values.Valor) || formik.values.Valor < 0 ? 0 : formik.values.Valor}
          numeroCasasDecimais={2}
          selecionaValorOnFocus={true}
          campoNullavel={true}
          disabled={props.somenteLeitura || props.desativarEdicaoValor}
        />
      </div>
    </>
  ), [formik.values.Valor, formik.errors.Valor, validado, props.somenteLeitura, props.desativarEdicaoValor, formik]);

  const numeroDocumentoInput = useMemo(() => (
    <>
      <label htmlFor="IncluirEditarParcela_NumeroDocumento">Nº Documento</label>
      <input
        type="text"
        id="IncluirEditarParcela_NumeroDocumento"
        maxLength={11}
        name="NumeroDocumento"
        disabled={props.somenteLeitura}
        value={(formik.values.NumeroDocumento) ?? ""}
        onChange={formik.handleChange}
      />
    </>
  ), [formik.values.NumeroDocumento, props.somenteLeitura, formik]);

  const bancoInput = useMemo(() => (
    <>
      <label htmlFor="IncluirEditarParcela_NumeroBanco">Banco</label>
      <input
        type="text"
        id="IncluirEditarParcela_NumeroBanco"
        name="NumeroBanco"
        disabled={props.somenteLeitura}
        value={(formik.values.NumeroBanco) ?? ""}
        onChange={formik.handleChange}
        maxLength={3}
      />
    </>
  ), [formik.values.NumeroBanco, props.somenteLeitura, formik]);

  const agenciaInput = useMemo(() => (
    <>
      <label htmlFor="IncluirEditarParcela_NumeroAgencia">Agência</label>
      <input
        type="text"
        id="IncluirEditarParcela_NumeroAgencia"
        name="NumeroAgencia"
        disabled={props.somenteLeitura}
        value={(formik.values.NumeroAgencia) ?? ""}
        onChange={formik.handleChange}
        maxLength={4}
      />
    </>
  ), [formik.values.NumeroAgencia, props.somenteLeitura, formik]);

  const contaInput = useMemo(() => (
    <>
      <label htmlFor="IncluirEditarParcela_NumeroConta">Conta</label>
      <input
        type="text"
        id="IncluirEditarParcela_NumeroConta"
        name="NumeroConta"
        disabled={props.somenteLeitura}
        value={(formik.values.NumeroConta) ?? ""}
        onChange={formik.handleChange}
        maxLength={16}
      />
    </>
  ), [formik.values.NumeroConta, props.somenteLeitura, formik]);

  const contaPortadoraInput = useMemo(() => (
    <>
      <label htmlFor="IncluirEditarParcela_ContaPortadora">Conta Portadora</label>
      <select
        id="IncluirEditarParcela_ContaPortadora"
        name="ContaPortadora"
        value={(formik.values.ContaPortadora) ?? ""}
        multiple={false}
        disabled={props.somenteLeitura || pixAPrazoHabilitado} // 414608
        onChange={(e) => {
          formik.handleChange(e);
        }}
      >
        <option value="">Selecione</option>
        {props.contasPortadoras?.map((value) => (
          <option key={value.Codigo} value={value.Codigo}>
            {value.Nome}
          </option>
        ))}
      </select>
    </>
  ), [formik.values.ContaPortadora, props.contasPortadoras, props.somenteLeitura, formik]);

  return ( props.parcela && 
    <> 
      <fieldset>
        <div>
          <div className={estiloIncluirEditarParcela.separador} />
          <div className={estilosFormulario.formulario}>
            {selectTipo}
            {selectTipoDocumento}
            {props.listaQuantidadeParcelas?.length > 0 && numeroParcelasComponent}
            {props.listaQuantidadeParcelas?.length > 0 && valorDasParcelasComponent}
            {codigoCMC7}
            {numeroDocumentoInput}
            {bancoInput}
            {agenciaInput}
            {contaInput}
            {contaPortadoraInput}
            {inputDataVencimento}
            {valorComponent}
            {props.exibirCheckboxReceberNaEntrega && checkboxReceberNaEntrega}
          </div>
        </div>
      </fieldset>
      <div>
        {formik.values.QuantidadeParcelasCartao > 1 && (
          <p>
            (*) O valor correto das parcelas deve ser verificado com a administradora de cartão
          </p>
        )}
        {!props.somenteLeitura && (
          <button
            id="IncluirEditarParcela_BotaoAplicar"
            className={estilosBotoes.botaoPrimario}
            onClick={async () => {
              // if (formik.values.Tipo == null || formik.values.Tipo <= 0) {
              //   globalMU.showErrorMessage("Selecione o tipo de parcela.");
              //   return false;
              // }
              if (formik.values.Tipo == null) {
                  globalMU.showErrorMessage("Selecione o tipo de parcela.");
                  return false;
              }
              if (formik.values.IdTipoDocumento != null) {
                const tipoDocumento = encontrarTipoDocumentoPorTipoParcela(props.tiposDocumento, formik.values.IdTipoDocumento, formik.values.Tipo); // 489850
                if (!validacaoTipoDocumento(tipoDocumento, formik.values.Tipo)) {
                  globalMU.showErrorMessage("Selecione o tipo de documento.");
                  return false;
                }
              }

              if (formik.values.Vencimento == undefined || globalMU.isNullOrEmpty(formik.values.Vencimento)) {
                globalMU.showErrorMessage("Informe o vencimento");
                return false;
              }

              if (formik.values.Valor == null || formik.values.Valor <= 0) {
                globalMU.showErrorMessage("Informe um valor válido");
                return false;
              }

              const erros = await formik.validateForm(formik.values);
              if (Object.keys(erros).length > 0) {
                
                props.onErrorValidacao(erros);
                return false;
              } else {
                
                props.onAplicar(formik.values);
                setValidado(true);
              }
            }}
          >
            Aplicar
          </button>
        )}
      </div>
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
});